export function buildPageUrl(
  staticPageUrl: string | null | undefined,
  options: { preview?: boolean } = {},
): string | null {
  if (!staticPageUrl) return null;
  try {
    const url = new URL(staticPageUrl);
    if (options.preview) url.searchParams.set('tinct_preview', '1');
    return url.toString();
  } catch {
    return null;
  }
}
